import React from 'react';

export function CurvedBackArrow() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M14.0937 6.21873H6.78125V3.65623C6.78125 3.21873 6.53125 2.84373 6.15625 2.65623C5.78125 2.49998 5.34375 2.56248 5 2.81248L0.96875 6.09373C0.71875 6.31248 0.5625 6.62498 0.5625 6.93748C0.5625 7.24998 0.71875 7.59373 0.96875 7.78123L5 11.0625C5.1875 11.2187 5.4375 11.3125 5.6875 11.3125C5.84375 11.3125 6 11.2812 6.15625 11.2187C6.53125 11.0312 6.78125 10.6562 6.78125 10.2187V7.65623H14.0937C16.2812 7.65623 18.0312 9.53123 18.0312 11.8437C18.0312 14.1562 16.25 16.0312 14.0937 16.0312H9.875C9.5 16.0312 9.15625 16.3437 9.15625 16.75C9.15625 17.1562 9.46875 17.4687 9.875 17.4687H14.0937C17.0312 17.4687 19.4375 14.9687 19.4375 11.875C19.4687 8.74998 17.0625 6.21873 14.0937 6.21873ZM5.375 9.56248L2.125 6.93748L5.375 4.31248V9.56248Z"
        fill="#2563EB"
      />
    </svg>
  );
}
